import { useAuth } from '../contexts/AuthContext';

/** ADMIN veya kullanıcıda servis fişi iptal izni açıksa true. */
export function useCanCancelServiceOrder(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  if (user.roleCodes?.includes('ADMIN')) return true;
  return user.canCancelServiceOrder === true;
}
